import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import cn from 'classnames'
import { identity } from 'lodash'
import { ChevronDown16 } from '@carbon/icons-react'

import FilterBarContext from '../../context'
import SelectAllCheckbox from '../../components/SelectAllCheckbox'

const AccordionButton = React.memo(
  ({ title, checkbox, expanded, hierarchy, onClick, onCheckboxClick }) => {
    const { filters } = useContext(FilterBarContext)

    return (
      <button type='button' onClick={onClick}>
        <div className='accordion-custom__item-title'>
          {checkbox && (
            <SelectAllCheckbox
              filters={filters}
              hierarchy={hierarchy}
              onCheckboxClick={onCheckboxClick}
            />
          )}
          <span>{title}</span>
        </div>
        <ChevronDown16 className={cn('icon', { rotated: expanded })} />
      </button>
    )
  }
)

AccordionButton.propTypes = {
  title: PropTypes.string,
  checkbox: PropTypes.bool,
  expanded: PropTypes.bool,
  hierarchy: PropTypes.arrayOf(PropTypes.string),
  onClick: PropTypes.func,
  onCheckboxClick: PropTypes.func
}

AccordionButton.defaultProps = {
  title: '',
  checkbox: false,
  expanded: false,
  hierarchy: [],
  onClick: identity,
  onCheckboxClick: identity
}

const SectionDescription = React.memo(({ text = '' }) => (
  <div className='section-description'>
    <p>{text}</p>
  </div>
))

export { AccordionButton, SectionDescription }
